export default function SectionAbout() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-5">
              关于春色影视
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-300 leading-relaxed">
              <p>
                春色影视成立于2024年，是一个专注于提供<strong className="text-primary-400 font-medium">高清免费在线观影</strong>服务的综合影视平台。我们秉持"不缓冲、不收费、不卡顿"的核心理念，致力于为每一位观众打造极致的在线观影体验。
              </p>
              <p>
                平台内容涵盖<strong className="text-secondary-400 font-medium">电影、电视剧、综艺、动漫、纪录片</strong>等全品类，每日实时更新最新资源。通过先进的分布式CDN加速和智能调度技术，确保无论何时何地都能实现秒开播放。
              </p>
              <p>
                我们相信，好的内容应该被所有人看见。春色影视将持续优化技术、丰富片库，以<strong className="text-accent-400 font-medium">免费不收费</strong>的方式让优质影视触手可及，成为你最值得信赖的在线观影伙伴。
              </p>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-lg overflow-hidden bg-background-200/50 border border-background-300/30">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20film%20projector%20icon%20design%2C%20warm%20golden%20light%20beam%2C%20dark%20atmospheric%20background%2C%20modern%20cinema%20aesthetic%2C%20clean%20geometric%20composition%2C%20no%20text%2C%20iconic%20brand%20visual&width=400&height=400&seq=about-chunse-01&orientation=squarish"
                alt="春色影视品牌标识"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
          {[
            { num: '10000+', label: '影视资源' },
            { num: '5000万+', label: '月活用户' },
            { num: '99.9%', label: '播放成功率' },
            { num: '24h', label: '更新周期' },
          ].map((stat, i) => (
            <div key={i} className="text-center p-4 rounded-lg bg-background-100/60 border border-background-300/20">
              <div className="text-xl md:text-2xl font-heading font-bold text-primary-400">{stat.num}</div>
              <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}